'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultFetch;

var _apiClient = require('hub-http/clients/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultFetch(path, data) {
  return _apiClient2.default.post(path, { data: data });
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.1456/js/api/defaultFetchAvatars.js
// module id = 184
// module chunks = 171